import { getCookie } from "./cookie/client";

const checkPreviewMode = (serverReq, cookieName = "contentfulPreview") => {
	const isBrowser = !serverReq;
	const cookieValue = isBrowser ? getCookie(cookieName) : serverReq.cookies[cookieName];
	if (cookieValue) {
		return true;
	}
	return false;
};

export default checkPreviewMode;
